import { formatWord } from 'utils/helperMethods';

//naive english pluraliser — only ever applied to the last word of a filter label
export function pluralizeLabel(word: string) {
    if (!word) return '';
    if (/s$/i.test(word)) return word;
    if (/[^aeiou]y$/i.test(word)) return `${word.slice(0, -1)}ies`;
    if (/(ch|sh|x|z)$/i.test(word)) return `${word}es`;
    return `${word}s`;
}

//heading of the attribute selection card, e.g. manufacturer -> "Choose Manufacturers"
export function attributeCardTitle(attributeTypeName: string) {
    return `Choose ${pluralizeLabel(formatWord(attributeTypeName))}`;
}
